import { render, staticRenderFns } from "./editDetails.vue?vue&type=template&id=268f7329&scoped=true&lang=pug"
import script from "./editDetails.vue?vue&type=script&lang=js"
export * from "./editDetails.vue?vue&type=script&lang=js"
import style0 from "./editDetails.vue?vue&type=style&index=0&id=268f7329&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268f7329",
  null
  
)

export default component.exports